<template>
	<el-container class="authorization">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-row :gutter="0">
				<el-col :span="4">
					<el-card class="tree-box">
						<el-scrollbar style="height:100%">
							<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" :default-expand-all="true"></el-tree>
						</el-scrollbar>
					</el-card>
				</el-col>
				<el-col :span="20">
					<div class="box">
						<el-card class="screen-box">
							<el-form ref="form" :model="searchForm" :inline="true" size="small">
								<el-form-item label="学生姓名:">
									<el-input placeholder="请输入学生姓名" v-model="searchForm.nick"></el-input>
								</el-form-item>
								<el-form-item label="学生编号:">
									<el-input placeholder="请输入学生编号" v-model="searchForm.studentNo"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
									<el-button type="primary" size="small" @click="authorizationAll()">授权账号时间</el-button>
									<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
								</el-form-item>
							</el-form>
						</el-card>
						<el-card class="table-box">
							<el-table :data="tableList" id="table" border>
								<el-table-column type="index" width="50"></el-table-column>
								<template v-for="(item, index) in tableLabel">
									<el-table-column :key="index" :prop="item.prop" :label="item.label"
										:formatter="item.formatter">
									</el-table-column>
								</template>
								<el-table-column label="操作" width="180">
									<template slot-scope="scope">
										<el-button type="text" size="mini" @click="check(scope.row)">查看推送情况</el-button>
										<el-button type="text" size="mini" @click="authorization(scope.row)" style="margin: 0 0 0 5px;">授权账号时间</el-button>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
						</el-card>
					</div>
				</el-col>
			</el-row>
		</el-main>
		<!-- 弹出层:授权账号时间 -->
		<el-dialog title="授权账号时间" :visible.sync="dialogVisible">
			<el-form :model="form" label-width="100px" size="small">
				<el-form-item label="账号有效时间">
					<el-date-picker v-model="form.accountExpired" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>
				<el-form-item label="发布对象">
					<el-radio-group v-model="form.type" @change="radioChange">
						<el-radio label="班级" value="1"></el-radio>
						<el-radio label="学生" value="2"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="text">
					<el-card class="sel-box">
						<div class="classAndGrade" v-if="form.type == '班级'" >
							<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
							<el-tree ref="tree" :data="data" :props="defaultProps" @node-click="dialogHandleNodeClick"
							:default-expand-all="true" show-checkbox @check-change="handleCheckChange" :filter-node-method="filterNode"></el-tree>
						</div>
						<div class="student" v-if="form.type == '学生'">
							<el-tag :key="tag.id" v-for="(tag,index) in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag,index)">
								{{tag.label}}
							</el-tag>
							<el-input placeholder="输入学生姓名进行搜索" v-model="msgInput" @input="handlerChange" style="width: 100% !important;"></el-input>
							<el-tree :data="msgTreeData" :props="msgTreeDefaultProps" :default-expand-all="true" show-checkbox @check-change="msghHandleCheckChange"></el-tree>
						</div>
					</el-card>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="confirm()" size="small">确 认</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
	import { authorizePageApi,authorizeIsPushApi,authorizeAccountExpiredApi,authorizeClassTreeApi,authorizeLikeNameTreeApi } from "@/axios/api";
	export default {
		name: "Authorization",
		data() {
			return {
				totalCount:0,
				pageSizes:[10],
				searchForm: {
					nick:'',//学生名称
					studentNo:'',//学生编号
					hikClassIds:'',//班级ID
					isSearchCount:true,
					page:1,
					limit:10
				},
				tableList: [],
				tableLabel: [{
					label: "企微学生姓名",
					prop: "cpStudentName"
				},{
					label: "企微学号",
					prop: "cpStudentNo"
				}, {
					label: "海康学生姓名",
					prop: "hikStudentName"
				}, {
					label: "海康学号",
					prop: "hikStudentNumber"
				}, {
					label: "班级名称",
					prop: "className"
				}, {
					label: "授权结束时间",
					prop: "accountExpired"
				}],
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				
				form: {
					accountExpired: '',
					ids: [],
					type: ''
				},
				dialogVisible: false,
				filterText: '',
				text:'',
				dynamicTags: [],
				msgInput:'',
				msgTreeData:[],
				msgTreeDefaultProps: {
					children: 'children',
					label: 'label'
				},
			}
		},
		created(){
			this.getData();
			authorizeClassTreeApi({}).then((res) => {
				if (res.code == 200) {
					this.data = res.data;
				}
			}).catch((err) => {});
		},
		methods: {
			getData(){
				authorizePageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm = {
					nick:'',
					studentNo:'',
					hikClassIds:'',
					isSearchCount:true,
					page:1,
					limit:10
				};
				this.getData();
			},
			//查看推送情况
			check(row){
				authorizeIsPushApi({hikStudentNumber:row.hikStudentNumber}).then((res) => {
					if (res.code == 200) {
						if(res.data){
							this.$message.success("推送正常");
						}else{
							this.$message.erroe("推送不正常");
						}
					}
				}).catch((err) => {});
			},
			//授权账号时间
			authorizationAll(){
				this.form.type = '班级';
				this.text = '班级';
				this.dialogVisible = true;
			},
			authorization(row){
				this.form.type = '学生';
				this.text = '学生';
				row.label = row.hikStudentName + '(' + row.className + ')';
				this.dynamicTags = [];
				this.dynamicTags.push(row);
				this.dialogVisible = true;
			},
			radioChange(val){
				this.text = val;
			},
			confirm(){
				var sendIds = [];
				if(this.form.type == '学生'){
					for(var i=0;i<this.dynamicTags.length;i++){
						sendIds.push(this.dynamicTags[i].id)
					}
				}else{
					sendIds = this.noRepeat(this.form.ids);
				}
				this.form.ids = sendIds;
				this.form.type = this.form.type == '学生' ? '2' : '1';
				authorizeAccountExpiredApi(this.form).then((res) => {
					if (res.code == 200) {
						this.$message.success("保存成功");
						this.dialogVisible = false;
						this.getData();
					}
				}).catch((err) => {});
			},
			//树
			handleNodeClick(data,node) {
				console.log(data)
			    node.expanded = true;
			    if(data.childrenIds == null){
			    	this.searchForm.hikClassIds = [];
			    }else{
			    	this.searchForm.hikClassIds = data.childrenIds.join(',');
			    }
			    this.searchForm.page = 1;
			    this.getData();
			},
			dialogHandleNodeClick(data, node) {
				node.expanded = true
			},
			handleCheckChange(data, checked, indeterminate) {
				if(data.childrenIds != null && data.childrenIds.length == 1){
					if(checked){
						this.form.ids.push(data.childrenIds);
					}else{
						var index = this.form.ids.indexOf(data.childrenIds);
						if (index > -1) {
							this.form.ids.splice(index, 1);
						}
					}
				}
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			msghHandleCheckChange(data, checked, indeterminate){
				if(this.dynamicTags.length == 0){
					this.dynamicTags.push(data);
					this.msgTreeData = [];
					this.msgInput = '';
				}else{
					var flag=false;
					for(var i = 0;i<this.dynamicTags.length;i++){
						if(this.dynamicTags[i].id == data.id){
							flag=true;
						}
					}
					if(flag==false){
						this.dynamicTags.push(data);
						this.msgTreeData = [];
						this.msgInput = '';
					}
				}
			},
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			},
			//数组去重
			noRepeat(arr){
				var newArr=[]; 
				for(var i=0;i<arr.length;i++) {
					if(newArr.indexOf(arr[i][0]) === -1) {
						newArr.push(arr[i][0]);
					}
				}
				return newArr
			},
			//标签X
			handleClose(tag,i) {
				this.dynamicTags.splice(i, 1);
			},
			//输入学生姓名进行搜索
			handlerChange(e){
				if(e.length >= 2){
					authorizeLikeNameTreeApi({name:e}).then((res) => {
						if (res.code == 200) {
							for(var i =0;i<res.data.length;i++){
								res.data[i].label = res.data[i].studentName + '(' + res.data[i].className + ')'
							}
							this.msgTreeData = res.data;
						}
					}).catch((err) => {});
				}else{
					this.msgTreeData = [];
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.tree-box .is-horizontal{
		display: none;
	}
	/deep/.tree-box .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	/deep/.tree-box .el-tree{
		border: 1px solid #EBEEF5;
		padding: 15px 0;
	}
	.student{
		min-height: 200px;
	}
	/deep/.el-dialog{
		height: 70vh;
		overflow-y: scroll;
	}
</style>
